export const isDESKTOP = import.meta.env.VITE_DESKTOP_MODE == "true";
